import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const languages = [
    { code: 'es', label: 'ES', flag: "/img/portfolio/es.svg" },
    { code: 'en', label: 'EN', flag: "/img/portfolio/en.svg" },
  ];

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('click', onDoc);
    return () => document.removeEventListener('click', onDoc);
  }, []);

  const changeLang = (code) => {
    if (i18n.language === code) { setOpen(false); return; }
    // navigate to same route but with new lang prefix
    const path = location.pathname.replace(/^\/(es|en)/, `/${code}`);
    i18n.changeLanguage(code);
    navigate(path);
    setOpen(false);
  };

  const current = languages.find((l) => l.code === i18n.language) || languages[1];

  return (
    <div className="language-selector" ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="btn btn-link language-selector__button"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <img
          src={current.flag}
          alt={current.label}
          width="20"
          height="20"
          className="me-2"
        />
        {current.label}
       
      </button>
{open && (
  <ul
    className="language-selector__menu list-unstyled p-2"
    role="listbox"
    style={{
      position: 'absolute',
      right: 0,
      background: '#fff',
      boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
      borderRadius: 6
    }}
  >
    {languages
      .filter((lang) => lang.code !== i18n.language)
      .map((lang) => (
        <li key={lang.code}>
          <button
            type="button"
            className="btn btn-link w-100 text-start d-flex align-items-center"
            onClick={() => changeLang(lang.code)}
          >
            <img
              src={lang.flag}
              alt={lang.label}
              width="20"
              height="20"
              className="me-2"
            />
            {lang.label}
          </button>
        </li>
      ))}
  </ul>
)}
    </div>
  );
}

